import {
  FIRST_HEADER,
  FIRST_TITLE,
  AFPercent_HEADER,
  AFPercent_TITLE,
  LAST_HEADER,
  LAST_TITLE,
} from "stats/RoundStats";
import { StatTableColumn } from "../../StatTableColumn";
import { SharedDriverTournamentStats } from "stats/Tournament/Shared";
import { DNF_HEADER, DNF_TITLE } from "stats/TimeStats";
import { nonUndefined } from "Utility";
import {
  getRatingTitle,
  RATING_HEADERS,
  RatingType,
} from "stats/Rating/RatingTypes";

export const getSharedDriverTournamentStatTableColumns = (
  ratingType: RatingType
): StatTableColumn<SharedDriverTournamentStats>[] => {
  return nonUndefined([
    {
      type: "OrgLogoName",
      sortable: true,
      orgIdGetter: (arg) => arg.orgId,
      nameGetter: (arg) => arg.driverName,
      smallerSize: true,
    },
    {
      type: "Number",
      header: RATING_HEADERS[ratingType],
      title: getRatingTitle(ratingType),
      sortable: true,
      valueGetter: (arg) => arg.driverRating,
      fractionDigits: 2,
      sortDescFirst: true,
    },
    {
      type: "Percent",
      header: AFPercent_HEADER,
      title: AFPercent_TITLE,
      sortable: true,
      rateGetter: (arg) => arg.averageFinishPercentile,
      fractionDigits: 1,
      sortDescFirst: true,
    },
    {
      type: "Percent",
      header: FIRST_HEADER,
      title: FIRST_TITLE,
      sortable: true,
      rateGetter: (arg) => arg.firstRate.rate,
      subTextGetter: (arg) => arg.firstRate.breakdown,
      fractionDigits: 1,
      sortDescFirst: true,
    },
    {
      type: "Percent",
      header: LAST_HEADER,
      title: LAST_TITLE,
      sortable: true,
      rateGetter: (arg) => arg.lastRate.rate,
      subTextGetter: (arg) => arg.lastRate.breakdown,
      fractionDigits: 1,
      sortDescFirst: true,
    },
    {
      type: "Percent",
      header: DNF_HEADER,
      title: DNF_TITLE,
      sortable: true,
      rateGetter: (arg) => arg.dnfRate.rate,
      subTextGetter: (arg) => arg.dnfRate.breakdown,
      fractionDigits: 1,
      sortDescFirst: true,
    },
  ]);
};
